import { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import uniqBy from 'lodash/uniqBy';
import { BzButton, BzChip, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../../components";

// Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- Start
const arrAlertsFactor = [
    {
        label: 'Last Traded Price',
        value: 'LASTTRADEDPRICE'
    },
    {
        label: 'Bid Price',
        value: 'BIDPRICE'
    },
    {
        label: 'Offer Price',
        value: 'OFFERPRICE'
    },
    {
        label: 'Last Traded Quantity',
        value: 'LASTTRADEDQUANTITY'
    },
    {
        label: 'Bid Quantity',
        value: 'BIDQUANTITY'
    },
    {
        label: 'Offer Quantity',
        value: 'OFFERQUANTITY'
    },
];

const arrAlertsCategories = [
    {
        label: 'Equity',
        value: 'EQ'
    },
    {
        label: 'F&O',
        value: 'FAO'
    },
];

const SideAlertsFilterModal = ({ selectedAlerts, selectedCategory, isShow = true, setIsShow, handleCategoryFilter, handlerAlertsFilter, applyFilter, applyReset, arrActiveAlerts, ...props }) => {
    const uniqueAlertsByFactor = uniqBy(arrActiveAlerts, 'factor1');
    const uniqueAlerts = uniqueAlertsByFactor.map(el1 => arrAlertsFactor.find(el2 => el1.factor1 === el2.value));

    const uniqueAlertsByCategory = uniqBy(arrActiveAlerts, 'category');
    const uniqueAlertsCategory = uniqueAlertsByCategory.map(el1 => arrAlertsCategories.find(el2 => (el1.category === el2.value)));

    return (
        <Row className='g-0'>
            <Col>
                <BzModal size='lg' show={isShow} onHide={setIsShow}>
                    <BzModalHeader className='modaltabs-header'>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col md={11} className='d-flex justify-content-start align-self-center'>
                                    <div className='font-medium font-size4 color-text'>Filters</div>
                                </Col>
                                <Col md={1} className='d-flex justify-content-end align-self-center'>
                                    <div onClick={() => { setIsShow(false); }} className='icon-16 icon-close icon-dark'></div>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalHeader>
                    <BzModalBody>
                        <Row className='g-0'>
                            <Col md={6}>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size3 color-text'>Category</div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col className='multi-chips-wrap'>
                                        {uniqueAlertsCategory?.map(el => <BzChip key={el?.value} onClick={() => handleCategoryFilter(el?.value)} value={el?.value} className={`multi-chip me-2 mb-2 ${el?.value === selectedCategory ? 'active' : ''}`}>{el?.label}</BzChip>)}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size3 color-text'>Alerts</div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col className='multi-chips-wrap'>
                                        {uniqueAlerts?.map(alert => (
                                            <BzChip key={alert?.value} onClick={() => handlerAlertsFilter(alert?.value)} value={alert?.value} className={`multi-chip me-2 mb-2 font-size3 ${alert?.value === selectedAlerts ? 'active' : ''}`}>{alert?.label}</BzChip>
                                        ))}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </BzModalBody>
                    <BzModalFooter>
                        <Container fluid className='m-0 p-0'>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-end aign-items-center'>
                                    <BzButton className='btn btn-outline font-size2 me-3' onClick={applyReset}>Reset Filters</BzButton>
                                    <BzButton className='btn btn-primary font-size2' onClick={applyFilter}>Apply</BzButton>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalFooter>
                </BzModal>
            </Col>
        </Row>
    );

};
export default memo(SideAlertsFilterModal);
// Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- End
